export default [
  {
    path: 'questionnaireList',
    name: 'QuestionnaireList',
    meta: {
      title: '问卷列表'
    },
    component: () => import('../views/exerland/questionnaire/questionnaireList.vue')
  },
  {
    path: 'questionnaireDetail',
    name: 'QuestionnaireDetail',
    meta: {
      title: '问卷详情',
      keepAlive: true
    },
    component: () => import('../views/exerland/questionnaire/questionnaireDetail.vue')
  },
  {
    path: 'questionnaireResultList',
    name: 'QuestionnaireResultList',
    meta: {
      title: '问卷结果'
    },
    component: () => import('../views/exerland/questionnaire/questionnaireResultList.vue')
  },
  {
    path: 'questionnaireResultDetail',
    name: 'QuestionnaireResultDetail',
    meta: {
      title: '问卷结果详情',
      keepAlive: true
    },
    component: () => import('../views/exerland/questionnaire/questionnaireResultDetail.vue')
  }
]
